let HGDeviceInfo = {
  getDeviceInfo: function(result) {
    dsBridge.call("HGDeviceInfo.getDeviceInfo", "设备信息", result);
  },
  getLocation: function(params, result) {
    dsBridge.call("HGDeviceInfo.getLocation", params, result);
  }
};

let HGCamera = {
  getImage: function(params, result) {
    dsBridge.call("HGCamera.getImage", params, result);
  }
};

let HGFile = {
  getFileContent: function(params, result) {
    dsBridge.call("HGFile.getFileContent", params, result);
  },
  previewFileWithCas: function(params, result) {
    if (!params) {
      return;
    }
    dsBridge.call("HGFile.previewFileWithCas", params, result);
  }
};

let HGEnDecrypt = {
  SM4SysEnDecrypt: function(params, result) {
    dsBridge.call("HGEnDecrypt.SM4SysEnDecrypt", params, result);
  }
};

let HGPay = {
  openPaymentApp: function(params, result) {
    dsBridge.call("HGPay.openPaymentApp", params, result);
  }
};

let HGMeeting = {
  joinMeeting: function(params, result) {
    if (!params) {
      return;
    }
    dsBridge.call("HGMeeting.joinMeeting", params, result);
  }
};

export default {
  HGDeviceInfo,
  HGCamera,
  HGFile,
  HGEnDecrypt,
  HGPay,
  HGMeeting
};